import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

class AuthorManagement extends Component {
  state = {
    currentStep: 1, // 1: years, 2: months, 3: authors
    years: [],
    months: [],
    authors: [],
    selectedYear: null,
    selectedMonth: null,
    pageNo: 1,
    length: 0,
    newAuthor: "",
    authorImage: null,
    editingMonth: "",
    editingQuote: null,
    profileLink: "", // New field
    editingAuthor: null,
    showPopup: false,
    showQuotePopup: false,
    showAddQuotePopup: false,
    showEditQuotePopup: false,
    selectedAuthor: null,
    newQuote: "",
    newQuoteTitle: "",
    newStoryLink: "",
    windowWidth: window.innerWidth,
    editingYear: '',
    showSelectSpotlightPopup: false,
    selectSpotlightYear: '',
    selectSpotlightMonth: '',
    selectSpotlightYearsList: [],
    selectSpotlightMonthsList: [],
    isSubmittingSelectSpotlight: false,
    // Live spotlight state (most recently created active spotlight = what's on the frontend)
    liveSpotlightId: null,
    liveSpotlightYear: null,
    liveSpotlightMonth: null,
  };

// Add this method to your component
componentDidMount() {
  this.fetchYears();
  window.addEventListener('resize', this.handleResize);
}

componentWillUnmount() {
  window.removeEventListener('resize', this.handleResize);
}

handleResize = () => {
  this.setState({ windowWidth: window.innerWidth });
};



  fetchYears = async () => {
    try {
      let token = getAccessToken();
      const response = await Axios.get(`${Constant.apiBasePath}spotlight/years`, { headers: { token } });
      const { data } = response.data;
      this.setState({ years: data || [], currentStep: 1, selectedYear: null, selectedMonth: null, months: [], authors: [] });
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };

  handleYearClick = async (year) => {
    try {
      let token = getAccessToken();
      const response = await Axios.get(`${Constant.apiBasePath}spotlight/months/${year}`, { headers: { token } });
      const { data } = response.data;
      this.setState({ months: data || [], currentStep: 2, selectedYear: year, selectedMonth: null, authors: [] });
    } catch (error) {
      console.error("Error fetching months:", error);
    }
  };

  handleMonthClick = async (month) => {
    const { selectedYear } = this.state;
    try {
      let token = getAccessToken();

      // Force backend to ensure there is a live spotlight selected
      // before we fetch this month's list.
      const liveRes = await Axios.get(
        `${Constant.apiBasePath}spotlight/author/get-all`,
        { headers: { token } }
      ).catch(() => null);

      let liveSpotlightId = null;
      let liveSpotlightYear = null;
      let liveSpotlightMonth = null;
      if (liveRes && liveRes.data?.data?.length > 0) {
        const live = liveRes.data.data[0];
        liveSpotlightId = live?._id ?? null;
        liveSpotlightYear = live?.year ?? null;
        liveSpotlightMonth = live?.month ?? null;
      }

      const authorsRes = await Axios.get(
        `${Constant.apiBasePath}spotlight/list/${selectedYear}/${month}`,
        { headers: { token } }
      );

      const { data } = authorsRes.data;

      this.setState({
        authors: data || [],
        currentStep: 3,
        selectedMonth: month,
        liveSpotlightId,
        liveSpotlightYear,
        liveSpotlightMonth,
      });
    } catch (error) {
      console.error("Error fetching authors for month:", error);
    }
  };

  handleBack = () => {
    const { currentStep } = this.state;
    if (currentStep === 2) {
      this.fetchYears();
    } else if (currentStep === 3) {
      this.handleYearClick(this.state.selectedYear);
    }
  };

  handleToggleActive = async (authorId) => {
    try {
      let token = getAccessToken();
      const response = await Axios.patch(`${Constant.apiBasePath}spotlight/toggle-active/${authorId}`, {}, { headers: { token } });
      if (response.data.status === "success" || response.data.status === "Success") {
        // Refresh authors and live selection for the current month
        this.handleMonthClick(this.state.selectedMonth);
      }
    } catch (error) {
      console.error("Error toggling active status:", error);
    }
  };

  handleSetLive = async (authorId) => {
    try {
      let token = getAccessToken();
      await Axios.patch(
        `${Constant.apiBasePath}spotlight/set-live/${authorId}`,
        {},
        { headers: { token } }
      );

      // Refresh authors and live state for the current month.
      this.handleMonthClick(this.state.selectedMonth);
    } catch (error) {
      console.error("Error setting spotlight live:", error);
    }
  };

  fetchAuthors = async () => {
    try {
      let token = getAccessToken();
      const response = await Axios.get(
        `${Constant.apiBasePath}spotlight/author/get-all`,
        { headers: { token } }
      );
      const { data } = response.data;
      this.setState({
        authors: data || [],
        pageNo: data.pageNo || 1,
        length: data.length || 0,
      });
    } catch (error) {
      console.error("Error fetching authors:", error);
    }
  };

  togglePopup = (author = null, quote = null) => {
    this.setState((prevState) => ({
      showPopup: !prevState.showPopup,
      newAuthor: author ? author.author : "",
      authorImage: author ? author.imageUrl || null : null,
      editingMonth: author ? author.month || "" : "",
      profileLink: author ? author.profileLink || "" : "", // Populate profileLink
      editingAuthor: author,
      editingQuote: quote,
      editingYear: author ? author.year || '' : '',
    }));
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageUpload = async (file) => {
    try {
      if (!file) {
        alert("Please select a file.");
        return;
      }

      let token = getAccessToken();
      let formData = new FormData();
      formData.append("spotlight", file, file.name);
      const response = await Axios.post(
        `${Constant.apiBasePath}spotlight/uploadFileOnS3`,
        formData,
        { headers: { token, "Content-Type": "multipart/form-data" } }
      );

      const { data } = response;
      if (data.status === "Success") {
        this.setState({ authorImage: data.location });
      } else {
        console.error("Error uploading image:", data.message);
        alert("Image upload failed.");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Image upload failed.");
    }
  };

  addOrUpdateAuthor = async () => {
    try {
      const {
        newAuthor,
        editingAuthor,
        authorImage,
        editingMonth,
        profileLink,
        editingYear,
        currentStep,
        selectedYear,
        selectedMonth,
      } = this.state;

      if (!newAuthor.trim()) {
        alert("Author name is required.");
        return;
      }

      if (profileLink && !/^(http|https):\/\/[^ "]+$/.test(profileLink)) {
        alert("Invalid profile link URL.");
        return;
      }

      let yearToSend = currentStep === 3 ? selectedYear : editingYear;
      let monthToSend = currentStep === 3 ? selectedMonth : editingMonth;

      if (!yearToSend) {
        alert('Year is required.');
        return;
      }
      if (!monthToSend) {
        alert('Month is required.');
        return;
      }

      let token = getAccessToken();
      let response;

      if (editingAuthor) {
        response = await Axios.patch(
          `${Constant.apiBasePath}spotlight/author/${editingAuthor._id}`,
          {
            author: newAuthor,
            imageUrl: authorImage,
            month: monthToSend,
            year: yearToSend,
            profileLink, // Include profileLink
          },
          { headers: { token } }
        );
      } else {
        response = await Axios.post(
          `${Constant.apiBasePath}spotlight/author`,
          {
            author: newAuthor,
            imageUrl: authorImage,
            month: monthToSend,
            year: yearToSend,
            profileLink, // Include profileLink
          },
          { headers: { token } }
        );
      }

      const { data } = response;
      if (data.status === "Success" || data.status === "success") {
        this.fetchAuthors();
        this.setState({ showPopup: false });
        alert(
          editingAuthor
            ? "Author updated successfully!"
            : "Author created successfully!"
        );
      } else {
        console.error("Error saving data:", data.message);
        alert("An error occurred while saving data.");
      }
    } catch (error) {
      console.error("Error adding/updating author:", error);
      alert("An unexpected error occurred.");
    }
  };

  deleteAuthor = async (authorId) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        `${Constant.apiBasePath}spotlight/author/${authorId}`,
        { headers: { token } }
      );
      const { data } = response;
      if (data.status === "success") {
        this.setState((prevState) => ({
          authors: prevState.authors.filter(
            (author) => author._id !== authorId
          ),
        }));
      } else {
        console.error("Error deleting author:", data.message);
      }
    } catch (error) {
      console.error("Error deleting author:", error);
    }
  };

  toggleQuotePopup = (author = null) => {
    this.setState((prevState) => ({
      showQuotePopup: !prevState.showQuotePopup,
      selectedAuthor: author,
      showAddQuotePopup: false,
      showEditQuotePopup: false,
    }));
    this.resetFormFields();
  };

  toggleAddQuotePopup = () => {
    this.setState((prevState) => ({
      showAddQuotePopup: !prevState.showAddQuotePopup,
    }));
    this.resetFormFields();
  };

  toggleEditQuotePopup = (quote = null) => {
    this.setState((prevState) => ({
      showEditQuotePopup: !prevState.showEditQuotePopup,
      editingQuote: quote,
      newQuote: quote ? quote.quote : "",
      newQuoteTitle: quote ? quote.title : "",
      newStoryLink: quote ? quote.storyLink : "",
    }));
  };

  handleQuoteSubmit = async () => {
    try {
      const {
        selectedAuthor,
        editingQuote,
        newQuote,
        newQuoteTitle,
        newStoryLink,
      } = this.state;
      let token = getAccessToken();

      if (!newQuote.trim() || !newQuoteTitle.trim() || !newStoryLink.trim()) {
        alert("All fields are required");
        return;
      }

      const quoteData = {
        quote: newQuote,
        title: newQuoteTitle,
        storyLink: newStoryLink,
      };

      if (editingQuote) {
        // Update quote
        const response = await Axios.put(
          `${Constant.apiBasePath}spotlight/quote/${selectedAuthor._id}/${editingQuote._id}`,
          quoteData,
          { headers: { token } }
        );

        if (response.data.status === "Success") {
          // Get updated author data from response
          const updatedAuthorData = response.data.data;

          // Update authors array with new data
          const updatedAuthors = this.state.authors.map((author) =>
            author._id === updatedAuthorData._id ? updatedAuthorData : author
          );

          this.setState({
            authors: updatedAuthors,
            selectedAuthor: updatedAuthorData,
            showEditQuotePopup: false,
            newQuote: "",
            newQuoteTitle: "",
            newStoryLink: "",
            editingQuote: null,
          });
        }
      } else {
        // Add new quote
        const response = await Axios.post(
          `${Constant.apiBasePath}spotlight/quote/${selectedAuthor._id}`,
          quoteData,
          { headers: { token } }
        );

        if (response.data.status === "Success") {
          // Get updated author data from response
          const updatedAuthorData = response.data.data;

          // Update authors array with new data
          const updatedAuthors = this.state.authors.map((author) =>
            author._id === updatedAuthorData._id ? updatedAuthorData : author
          );

          this.setState({
            authors: updatedAuthors,
            selectedAuthor: updatedAuthorData,
            showAddQuotePopup: false,
            newQuote: "",
            newQuoteTitle: "",
            newStoryLink: "",
          });
          alert("Quote added successfully!");
        }
      }
    } catch (error) {
      console.error("Error saving quote:", error);
      alert("An error occurred while saving the quote.");
    }
  };

  deleteQuote = async (authorId, quoteId) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        `${Constant.apiBasePath}spotlight/quote/${authorId}/${quoteId}`,
        { headers: { token } }
      );

      if (response.data.status === "Success") {
        // Get updated author data from response
        const updatedAuthorData = response.data.data;

        // Update authors array with new data
        const updatedAuthors = this.state.authors.map((author) =>
          author._id === updatedAuthorData._id ? updatedAuthorData : author
        );

        this.setState({
          authors: updatedAuthors,
          selectedAuthor: updatedAuthorData,
        });
        alert("Quote deleted successfully!");
      }
    } catch (error) {
      console.error("Error deleting quote:", error);
      alert("An error occurred while deleting the quote.");
    }
  };

  resetFormFields = () => {
    this.setState({
      newQuote: "",
      newQuoteTitle: "",
      newStoryLink: "",
      editingQuote: null,
    });
  };

  openSelectSpotlightPopup = async () => {
    this.setState({ showSelectSpotlightPopup: true, selectSpotlightYear: '', selectSpotlightMonth: '', selectSpotlightMonthsList: [] });
    // Fetch years from API
    try {
      let token = getAccessToken();
      const response = await Axios.get(`${Constant.apiBasePath}spotlight/years`, { headers: { token } });
      const { data } = response.data;
      this.setState({ selectSpotlightYearsList: data || [] });
    } catch (error) {
      alert('Failed to fetch years');
    }
  };

  closeSelectSpotlightPopup = () => {
    this.setState({ showSelectSpotlightPopup: false });
  };

  handleSelectSpotlightYear = async (e) => {
    const year = e.target.value;
    this.setState({ selectSpotlightYear: year, selectSpotlightMonth: '', selectSpotlightMonthsList: [] });
    if (year) {
      // Fetch months for this year
      try {
        let token = getAccessToken();
        const response = await Axios.get(`${Constant.apiBasePath}spotlight/months/${year}`, { headers: { token } });
        const { data } = response.data;
        this.setState({ selectSpotlightMonthsList: data || [] });
      } catch (error) {
        alert('Failed to fetch months');
      }
    }
  };

  handleSelectSpotlightMonth = (e) => {
    this.setState({ selectSpotlightMonth: e.target.value });
  };

  handleSubmitSelectSpotlight = async () => {
    const { selectSpotlightYear, selectSpotlightMonth } = this.state;
    if (!selectSpotlightYear || !selectSpotlightMonth) {
      alert('Please select both year and month');
      return;
    }
    this.setState({ isSubmittingSelectSpotlight: true });
    try {
      let token = getAccessToken();
      const response = await Axios.post(`${Constant.apiBasePath}spotlight/selection`, {
        year: Number(selectSpotlightYear),
        month: selectSpotlightMonth,
      }, { headers: { token } });
      if (response.data.status === 'success' || response.data.status === 'Success') {
        alert('Spotlight selection submitted successfully!');
        this.setState({ showSelectSpotlightPopup: false });
      } else {
        alert('Failed to submit selection');
      }
    } catch (error) {
      alert('Error submitting selection');
    } finally {
      this.setState({ isSubmittingSelectSpotlight: false });
    }
  };

  render() {
    const {
      currentStep, years, months, authors, selectedYear, selectedMonth,
      showPopup, newAuthor, authorImage, profileLink, showQuotePopup, selectedAuthor,
      showAddQuotePopup, showEditQuotePopup, newQuote, newQuoteTitle, newStoryLink, windowWidth, editingYear,
      liveSpotlightId, liveSpotlightYear, liveSpotlightMonth,
    } = this.state;

    // Responsive grid columns
    let gridColumns = 3;
    if (windowWidth <= 576) gridColumns = 1;
    else if (windowWidth <= 992) gridColumns = 2;

    const gridStyle = {
      display: "grid",
      gridTemplateColumns: `repeat(${gridColumns}, 1fr)` ,
      gap: "20px",
      padding: "20px",
    };

    const monthsList = [
      'january', 'february', 'march', 'april', 'may', 'june',
      'july', 'august', 'september', 'october', 'november', 'december'
    ];

    // Step 1: Years
    if (currentStep === 1) {
      return (
        <div className="content-page">
          <div className="header-common">
            <div className="center-items" style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
              <h4 className="page-title-heading">Spotlight Years</h4>
              <button className="btn btn-info" onClick={() => this.togglePopup()}>Add New Spotlight</button>
            </div>
          </div>
          <div style={gridStyle}>
            {years.map((yearObj) => (
              <div key={yearObj.year} className="card" style={{ cursor: 'pointer', padding: 20, textAlign: 'center' }} onClick={() => this.handleYearClick(yearObj.year)}>
                <h3>{yearObj.year}</h3>
                <p>{yearObj.count} Spotlights</p>
              </div>
            ))}
          </div>
          {/* Add author popup remains as before */}
          {showPopup && (
            <div style={popupContainerStyle}>
              <div style={popupStyle}>
                <h4>{this.state.editingAuthor ? "Edit Spotlight" : "Add Spotlight"}</h4>
                <input type="text" name="newAuthor" placeholder="Spotlight Name" value={newAuthor} onChange={this.handleInputChange} style={inputStyle} />
                <input type="file" onChange={(e) => this.handleImageUpload(e.target.files[0])} style={inputStyle} />
                {/* Only show year/month dropdowns if NOT in a specific year/month context */}
                {currentStep !== 3 && (
                  <>
                    <select name="editingYear" value={this.state.editingYear || ''} onChange={this.handleInputChange} style={inputStyle} required>
                      <option value="">Select Year</option>
                      {Array.from({ length: 2050 - 2020 + 1 }, (_, i) => 2050 - i).map((y) => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                    <select name="editingMonth" value={this.state.editingMonth || ''} onChange={this.handleInputChange} style={inputStyle} required>
                      <option value="">Select Month</option>
                      {monthsList.map((m) => (
                        <option key={m} value={m}>{m.charAt(0).toUpperCase() + m.slice(1)}</option>
                      ))}
                    </select>
                  </>
                )}
                <input type="text" name="profileLink" placeholder="Profile Link" value={profileLink} onChange={this.handleInputChange} style={inputStyle} />
                {authorImage && (<div><img src={authorImage} alt="Spotlight" style={{ width: "100px", marginBottom: "15px" }} /></div>)}
                <button className="btn btn-secondary" onClick={this.togglePopup}>Cancel</button>
                <button className="btn btn-primary ml-2" onClick={this.addOrUpdateAuthor}>Save</button>
              </div>
            </div>
          )}
          {/* Year/Month selection flow removed; use Set as live + Add new spotlight */}
        </div>
      );
    }

    // Step 2: Months
    if (currentStep === 2) {
      return (
        <div className="content-page">
          <div className="header-common">
            <div className="center-items">
              <h4 className="page-title-heading">Spotlight Months - {selectedYear}</h4>
              <button className="btn btn-secondary ml-2" onClick={this.handleBack}>Back</button>
            </div>
          </div>
          <div style={gridStyle}>
            {months.map((monthObj) => (
              <div key={monthObj.month} className="card" style={{ cursor: 'pointer', padding: 20, textAlign: 'center' }} onClick={() => this.handleMonthClick(monthObj.month)}>
                <h3 style={{ textTransform: 'capitalize' }}>{monthObj.month}</h3>
                <p>{monthObj.count} Spotlights</p>
              </div>
            ))}
          </div>
        </div>
      );
    }

    // Step 3: Authors/Spotlights for selected month
    if (currentStep === 3) {
      // The frontend renders a single global live spotlight.
      // We highlight it using `author.isLive` (with a fallback match on `liveSpotlightId`).

      return (
        <div className="content-page">
          <div className="header-common">
            <div className="center-items">
              <h4 className="page-title-heading">Spotlights - {selectedYear} / {selectedMonth}</h4>
              <button className="btn btn-secondary ml-2" onClick={this.handleBack}>Back</button>
              <button className="btn btn-info ml-2" onClick={() => this.togglePopup()}>Add New Spotlight</button>
            </div>
          </div>

          {/* Legend */}
          <div
            style={{
              display: "flex",
              gap: 20,
              padding: "10px 20px",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 3,
                  background: "#d4edda",
                  border: "1px solid #28a745",
                  display: "inline-block",
                }}
              ></span>
              <span style={{ fontSize: 13 }}>Live (isLive = true)</span>
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 3,
                  background: "#fff3cd",
                  border: "1px solid #ffc107",
                  display: "inline-block",
                }}
              ></span>
              <span style={{ fontSize: 13 }}>Active (not live)</span>
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 3,
                  background: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  display: "inline-block",
                }}
              ></span>
              <span style={{ fontSize: 13 }}>Inactive</span>
            </span>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Spotlight</th>
                  <th>Image</th>
                  <th>Month</th>
                  <th>Year</th>
                  <th>Profile Link</th>
                  <th>Quote</th>
                  <th>Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {authors.map((author, index) => {
                  const isLive =
                    author.active &&
                    (author.isLive ||
                      (liveSpotlightId && author._id === liveSpotlightId));
                  const isActive = author.active;
                  let rowStyle = {};
                  if (isLive) {
                    rowStyle = { backgroundColor: '#d4edda' }; // green — live on frontend
                  } else if (isActive) {
                    rowStyle = { backgroundColor: '#fff3cd' }; // yellow — active but not shown
                  } else {
                    rowStyle = { backgroundColor: '#f8f9fa', opacity: 0.75 }; // grey — inactive
                  }
                  return (
                    <tr key={author._id} style={rowStyle}>
                      <td className="namecol">
                        {author.author}
                        {isLive && (
                          <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 700, color: '#155724', background: '#c3e6cb', padding: '2px 7px', borderRadius: 10, verticalAlign: 'middle' }}>
                            LIVE
                          </span>
                        )}
                      </td>
                      <td>{author.imageUrl && (<img src={author.imageUrl} alt="Spotlight" style={{ width: "50px", height: "50px" }} />)}</td>
                      <td>{author.month || "N/A"}</td>
                      <td>{author.year || "N/A"}</td>
                      <td className="namecol">{author.profileLink ? (<a href={author.profileLink} target="_blank" rel="noreferrer">View Profile</a>) : ("N/A")}</td>
                      <td>{author.quotes?.length || "N/A"}</td>
                      <td>
                        <button className={`btn btn-sm ${author.active ? 'btn-success' : 'btn-outline-secondary'}`} onClick={() => this.handleToggleActive(author._id)}>
                          {author.active ? 'Active' : 'Inactive'}
                        </button>
                      </td>
                      <td>
                        <button
                          className={`btn btn-sm mr-2 ${
                            isLive ? "btn-success" : "btn-outline-success"
                          }`}
                          disabled={!author.active || isLive}
                          onClick={() => this.handleSetLive(author._id)}
                        >
                          {isLive ? "Live" : "Set as live"}
                        </button>
                        <button
                          className="btn btn-primary mr-2"
                          onClick={() => this.togglePopup(author)}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className="btn btn-info mr-2"
                          onClick={() => this.toggleQuotePopup(author)}
                        >
                          Manage Quotes
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => this.deleteAuthor(author._id)}
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* Popups for add/edit author and quote management remain as before */}
          {showPopup && (
            <div style={popupContainerStyle}>
              <div style={popupStyle}>
                <h4>{this.state.editingAuthor ? "Edit Spotlight" : "Add Spotlight"}</h4>
                <input type="text" name="newAuthor" placeholder="Spotlight Name" value={newAuthor} onChange={this.handleInputChange} style={inputStyle} />
                <input type="file" onChange={(e) => this.handleImageUpload(e.target.files[0])} style={inputStyle} />
                {/* Only show year/month dropdowns if NOT in a specific year/month context */}
                {currentStep !== 3 && (
                  <>
                    <select name="editingYear" value={this.state.editingYear || ''} onChange={this.handleInputChange} style={inputStyle} required>
                      <option value="">Select Year</option>
                      {years.map((y) => (
                        <option key={y.year} value={y.year}>{y.year}</option>
                      ))}
                    </select>
                    <select name="editingMonth" value={this.state.editingMonth || ''} onChange={this.handleInputChange} style={inputStyle} required>
                      <option value="">Select Month</option>
                      {monthsList.map((m) => (
                        <option key={m} value={m}>{m.charAt(0).toUpperCase() + m.slice(1)}</option>
                      ))}
                    </select>
                  </>
                )}
                <input type="text" name="profileLink" placeholder="Profile Link" value={profileLink} onChange={this.handleInputChange} style={inputStyle} />
                {authorImage && (<div><img src={authorImage} alt="Spotlight" style={{ width: "100px", marginBottom: "15px" }} /></div>)}
                <button className="btn btn-secondary" onClick={this.togglePopup}>Cancel</button>
                <button className="btn btn-primary ml-2" onClick={this.addOrUpdateAuthor}>Save</button>
              </div>
            </div>
          )}
          {/* Quote management popups (showQuotePopup, showAddQuotePopup, showEditQuotePopup) remain as before */}
          {showQuotePopup && (
            <div style={popupContainerStyle}>
              <div className="quote-modal">
                {/* Header */}
                <div className="quote-modal-header">
                  <h4 style={{ margin: 0, marginBottom: "15px" }}>Quote Management</h4>
                  <button className="btn btn-success" onClick={this.toggleAddQuotePopup}>Add New Quote</button>
                </div>
                {/* Scrollable Body */}
                <div className="quote-modal-body">
                  {selectedAuthor && (
                    <div className="quote-grid">
                      {selectedAuthor.quotes.map((quote) => (
                        <div key={quote._id} className="quote-card">
                          <h5 className="mb-2">{quote.title}</h5>
                          <p className="mb-2" style={{ flex: 1 }}>{quote.quote}</p>
                          <a href={quote.storyLink} target="_blank" rel="noreferrer" className="mb-2 text-primary">Story Link</a>
                          <div className="d-flex gap-2" style={{ gap: "10px" }}>
                            <button className="btn btn-primary btn-sm" onClick={() => this.toggleEditQuotePopup(quote)}><FontAwesomeIcon icon={faEdit} /> Edit</button>
                            <button className="btn btn-danger btn-sm" onClick={() => this.deleteQuote(selectedAuthor._id, quote._id)}><FontAwesomeIcon icon={faTrashAlt} /> Delete</button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {/* Footer */}
                <div className="quote-modal-footer">
                  <button className="btn btn-secondary" onClick={this.toggleQuotePopup}>Close</button>
                </div>
              </div>
            </div>
          )}
          {/* Add/Edit Quote Popups remain as before */}
          {showAddQuotePopup && (
            <div style={popupContainerStyle}>
              <div style={popupStyle}>
                <h4>Add New Quote</h4>
                <input type="text" name="newQuoteTitle" placeholder="Title" value={newQuoteTitle} onChange={this.handleInputChange} style={inputStyle} />
                <textarea name="newQuote" placeholder="Quote" value={newQuote} onChange={this.handleInputChange} style={{ ...inputStyle, minHeight: "100px" }} />
                <input type="text" name="newStoryLink" placeholder="Story Link" value={newStoryLink} onChange={this.handleInputChange} style={inputStyle} />
                <button className="btn btn-secondary mr-2" onClick={this.toggleAddQuotePopup}>Cancel</button>
                <button className="btn btn-primary" onClick={this.handleQuoteSubmit}>Save Quote</button>
              </div>
            </div>
          )}
          {showEditQuotePopup && (
            <div style={popupContainerStyle}>
              <div style={popupStyle}>
                <h4>Edit Quote</h4>
                <input type="text" name="newQuoteTitle" placeholder="Title" value={newQuoteTitle} onChange={this.handleInputChange} style={inputStyle} />
                <textarea name="newQuote" placeholder="Quote" value={newQuote} onChange={this.handleInputChange} style={{ ...inputStyle, minHeight: "100px" }} />
                <input type="text" name="newStoryLink" placeholder="Story Link" value={newStoryLink} onChange={this.handleInputChange} style={inputStyle} />
                <button className="btn btn-secondary mr-2" onClick={this.toggleEditQuotePopup}>Cancel</button>
                <button className="btn btn-primary" onClick={this.handleQuoteSubmit}>Update Quote</button>
              </div>
            </div>
          )}
        </div>
      );
    }

    // Fallback (should not happen)
    return <div>Loading...</div>;
  }
}

export default withRouter(AuthorManagement);

const popupContainerStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const popupStyle = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "8px",
  width: "400px",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "15px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  color: "black",
};

// Also add this CSS to your stylesheet or in a <style> tag
const styles = `
  @media (max-width: 992px) {
    .quote-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }
  
  @media (max-width: 576px) {
    .quote-grid {
      grid-template-columns: 1fr !important;
    }
  }
  
  .quote-grid::-webkit-scrollbar {
    width: 8px;
  }
  
  .quote-grid::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .quote-grid::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  .quote-grid::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
